import React from 'react';

const Logo = props => (
    <svg viewBox="0 0 1071 131" xmlnsXlink="http://www.w3.org/1999/xlink" {...props}>
        <path
            className="argo-construction"
            d="M222.6 92.4l-4.8-12.2h-27L186 92.4h-7.7l21.8-54.8h8.4l21.9 54.8h-7.8zm-18.3-47.7l-11.5 29.5h23l-11.5-29.5zM269.6 92.4l-13.8-21.8H245v21.8h-6.7V37.6H260c9.9 0 17 6.4 17 16.5 0 9.9-6.7 15.3-14.1 15.9l14.6 22.3h-7.9zm.4-38.3c0-6.2-4.4-10.4-10.8-10.4H245v20.9h14.2c6.4 0 10.8-4.3 10.8-10.5zM286.3 65c0-17 12.4-28.3 27.9-28.3 9.6 0 16.3 4.3 21.1 10.3l-5.4 3.4c-3.4-4.4-9.2-7.6-15.7-7.6-11.9 0-20.9 9.2-20.9 22.3 0 13 9 22.3 20.9 22.3 6.5 0 11.9-3.2 14.6-5.9V70.3h-18.6v-6.1h25.4V84c-5 5.7-12.4 9.4-21.3 9.4-15.6 0-28-11.4-28-28.4zM345 65c0-16.2 10.8-28.3 26.9-28.3 16 0 26.9 12.2 26.9 28.3s-10.9 28.3-26.9 28.3C355.8 93.4 345 81.2 345 65zm46.8 0c0-12.8-7.8-22.3-19.9-22.3-12.2 0-19.9 9.4-19.9 22.3 0 12.7 7.7 22.3 19.9 22.3 12.1 0 19.9-9.5 19.9-22.3zM428.2 65c0-16.8 12.3-28.3 27.9-28.3 9.6 0 16.3 4.7 20.6 10.8l-5.7 3.2c-3.1-4.6-8.7-8-14.9-8-11.9 0-20.9 9.2-20.9 22.3 0 13 9 22.3 20.9 22.3 6.2 0 11.8-3.3 14.9-8l5.8 3.2c-4.6 6.2-11.1 10.8-20.7 10.8-15.7.1-27.9-11.4-27.9-28.3zM483.1 65c0-16.2 10.8-28.3 26.9-28.3 16 0 26.9 12.2 26.9 28.3S526 93.4 510 93.4c-16.1 0-26.9-12.2-26.9-28.4zm46.8 0c0-12.8-7.8-22.3-19.9-22.3-12.2 0-19.9 9.4-19.9 22.3 0 12.7 7.7 22.3 19.9 22.3 12.1 0 19.9-9.5 19.9-22.3zM585.9 92.4l-31.6-43.7v43.7h-6.7V37.6h6.9l31.2 42.8V37.6h6.7v54.8h-6.5zM601.8 84.7l4-5.2c3.6 4 9.4 7.8 17.1 7.8 9.7 0 12.8-5.3 12.8-9.4 0-14.1-32.1-6.3-32.1-25.9 0-9 8-15.2 18.6-15.2 8.3 0 14.7 2.8 19.3 7.6l-4.1 5c-4.1-4.5-9.8-6.6-15.7-6.6-6.5 0-11.1 3.5-11.1 8.7 0 12.3 32.1 5.3 32.1 25.7 0 8-5.4 16.1-20 16.1-9.5.1-16.4-3.5-20.9-8.6zM666.1 92.4V43.7H649v-6.1h41.1v6.1h-17.2v48.7h-6.8zM730.4 92.4l-13.8-21.8h-10.8v21.8H699V37.6h21.8c9.9 0 17 6.4 17 16.5 0 9.9-6.7 15.3-14.1 15.9l14.6 22.3h-7.9zm.4-38.3c0-6.2-4.4-10.4-10.8-10.4h-14.2v20.9H720c6.4 0 10.8-4.3 10.8-10.5zM748.5 71.1V37.6h6.7V71c0 10 5.4 16.3 15.4 16.3S786 81 786 71V37.6h6.7V71c0 13.6-7.4 22.3-22.1 22.3-14.7.1-22.1-8.7-22.1-22.2zM803.2 65c0-16.8 12.3-28.3 27.9-28.3 9.6 0 16.3 4.7 20.6 10.8l-5.7 3.2c-3.1-4.6-8.7-8-14.9-8-11.9 0-20.9 9.2-20.9 22.3 0 13 9 22.3 20.9 22.3 6.2 0 11.8-3.3 14.9-8l5.8 3.2c-4.6 6.2-11.1 10.8-20.6 10.8-15.7.1-28-11.4-28-28.3zM873.8 92.4V43.7h-17.2v-6.1h41.1v6.1h-17.2v48.7h-6.7zM906.7 92.4V37.6h6.7v54.8h-6.7zM923.9 65c0-16.2 10.8-28.3 26.9-28.3 16 0 26.9 12.2 26.9 28.3s-10.9 28.3-26.9 28.3c-16.1.1-26.9-12.1-26.9-28.3zm46.8 0c0-12.8-7.8-22.3-19.9-22.3-12.2 0-19.9 9.4-19.9 22.3 0 12.7 7.7 22.3 19.9 22.3 12.1 0 19.9-9.5 19.9-22.3zM1026.7 92.4l-31.6-43.7v43.7h-6.7V37.6h6.9l31.2 42.8V37.6h6.7v54.8h-6.5z"
            fill="#215183"
        />
        <path
            d="M82.1 89.3L104 73.1C67.1 78.9 43.5 90.8 37.7 94c2.2 0 34.7-.4 58.8 12.7L113.9 87c-17-.3-31.8 2.3-31.8 2.3M168.5 25L93.9 64.3h21.9L168.5 25z"
            fill="#11b5e9"
        />
        <defs>
            <path id="h" d="M37.6 25h130.9v81.7H37.6z" />
        </defs>
        <clipPath id="g">
            <use xlinkHref="#h" />
        </clipPath>
        <g clipPath="url(#g)">
            <defs>
                <path
                    id="f"
                    d="M82.1 89.3L104 73.1C67.1 78.9 43.5 90.8 37.7 94c2.2 0 34.7-.4 58.8 12.7L113.9 87c-17-.3-31.8 2.3-31.8 2.3M168.5 25L93.9 64.3h21.9L168.5 25z"
                />
            </defs>
            <clipPath id="e">
                <use xlinkHref="#f" />
            </clipPath>
            <linearGradient
                id="d"
                x1={-69.296}
                x2={-67.939}
                y1={372.42}
                y2={372.42}
                gradientTransform="matrix(62.753 -55.78 -55.78 -62.753 25187 19605)"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#fff" offset={0} />
                <stop stopColor="#EFF4F8" offset={0.065} />
                <stop stopColor="#A1BED4" offset={0.404} />
                <stop stopColor="#6897BA" offset={0.684} />
                <stop stopColor="#447EAA" offset={0.89} />
                <stop stopColor="#3775A4" offset={1} />
            </linearGradient>
            <path clipPath="url(#e)" fill="url(#d)" d="M-2.9 61L110.8-40l98.3 110.6-113.7 101z" />
        </g>
        <path
            className="st0"
            d="M82.1 89.3s14.8-2.7 31.7-2.4l14.6-16.6c-8.7.6-16.9 1.5-24.5 2.7L82.1 89.3zm33.7-25h18L168.5 25l-52.7 39.3z"
            fill="#215183"
        />
        <defs>
            <path
                id="c"
                d="M128.4 70.4L113.8 87c7 .1 14.4.8 21.2 2.3l10.2-19.5c-5.8 0-11.4.2-16.8.6m5.4-6.1H148L168.5 25l-34.7 39.3z"
            />
        </defs>
        <clipPath id="b">
            <use xlinkHref="#c" />
        </clipPath>
        <linearGradient
            id="a"
            x1={-69.402}
            x2={-68.046}
            y1={374.15}
            y2={374.15}
            gradientTransform="matrix(40.443 -57.6 -57.6 -40.443 24467 11237)"
            gradientUnits="userSpaceOnUse"
        >
            <stop stopColor="#6E727A" offset={0} />
            <stop stopColor="#888B92" offset={0.159} />
            <stop stopColor="#C9CACD" offset={0.496} />
            <stop stopColor="#DFE0E2" offset={0.604} />
            <stop stopColor="#999CA1" offset={0.784} />
            <stop stopColor="#676B73" offset={0.929} />
            <stop stopColor="#545861" offset={1} />
        </linearGradient>
        <path clipPath="url(#b)" fill="url(#a)" d="M83.5 68L131.9-.8l66.9 47-48.3 68.8z" />
    </svg>
);

export default Logo;
